// Flow types automatically removed

import { hydrateRoot } from 'react-dom/client';
import { QueryRenderer } from 'react-relay/legacy';
import { IntlProvider } from 'dibs-react-intl';
import serverVars from 'server-vars';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { getEnvironment } from '../relayModernEnvironment';
import InteriorPhotoWrapper from '../interiorsPhoto/InteriorPhotoWrapper';
import { PhotoRootQuery } from '../interiorsPhoto/PhotoRootQuery';
import { ServerVarsContextProvider } from '../shared/ServerVarsContext';
const locale = serverVars.get('locale');
const messages = serverVars.get('messages');
const photoPath = serverVars.get('photoPath');
const variables = serverVars.get('relayVariables');
const environment = getEnvironment(true);
initializeDBL().then(() => {
    const interiorPhotoDOMNode = document.getElementById('js-root');

    if (interiorPhotoDOMNode !== null) {
        hydrateRoot(
            interiorPhotoDOMNode,
            <IntlProvider locale={locale} messages={messages}>
                <ServerVarsContextProvider
                    isMobile={serverVars.get('settings.isMobile')}
                    isTablet={serverVars.get('settings.isTablet')}
                    isDesktop={serverVars.get('settings.isDesktop')}
                >
                    <QueryRenderer
                        environment={environment}
                        query={PhotoRootQuery}
                        variables={variables}
                        fetchPolicy="store-or-network"
                        render={({ props, error }) => {
                            if (error) {
                                // eslint-disable-next-line no-console
                                console.error('error!', error);
                                return null;
                            }

                            return (
                                <InteriorPhotoWrapper
                                    viewer={props?.viewer}
                                    initialLookupUrl={photoPath}
                                />
                            );
                        }}
                    />
                </ServerVarsContextProvider>
            </IntlProvider>
        );
    }
});
